module.exports = __webpack_public_path__ + "static/media/van.027036b9.jpg";